import React, { Component } from 'react'
import DocumentTitle from 'react-document-title';
import Div100vh from 'react-div-100vh';
import OutsideClickHandler from 'react-outside-click-handler';
import classNames from 'classnames';
import Button from '../../Button';
import FontAwesomeIcon from '../../Icon';
import './LeftNavigation.scss';
import WalkThroughSideBar from './WalkThroughSideBar';
import { Images } from '../../../Tenants';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { selectAuthenticatedUser } from '../../../store/selectors/auth';
import { selectCollapseSideBar } from '../../../store/selectors/collapseSideBar';
import { setSideBar } from '../../../store/actions/collapseSideBar';

class LeftNavigation extends Component {
 state = {
   sidebarIsVisible: false,
   collapsableSideBar: false
 }
 onClickSidebar(){
   this.setState({
     sidebarIsVisible:false
   })
 }
 onCollapsableSideBar() {
  const {collapsableSideBar} = this.state;
  const {onSetSideBar}=this.props
  this.setState({ collapsableSideBar: !collapsableSideBar });
  onSetSideBar(!collapsableSideBar)
}

 render() {
  const { from, bottom, title, top,body, user, onClose, reduceLeftPan, collapsableSideBar } = this.props;
  const { sidebarIsVisible } = this.state;
  const theme = localStorage.getItem('theme');

  return(
   <div> <DocumentTitle title={ theme === 'Shape'?`SHAPE | ${title} `:`${title} | juniper`}>
   <Div100vh className="left-navigation">
     <OutsideClickHandler
         onOutsideClick={() => {
           this.setState({ sidebarIsVisible: false })
         }}
       >
       <div
          className={from === "DeveloperWalkThrough" ?
            classNames(
              'with-navigation__aside',
              {
                'with-navigation__aside--visible': sidebarIsVisible,
                'with-navigation__aside--collapseWidth': collapsableSideBar
              }
            ):
            classNames(
              'left-navigation__aside',
              {
                'left-navigation__aside--visible': sidebarIsVisible,
                'left-navigation__aside--reduceWidth': reduceLeftPan,
              },
             //  {
             //   'left-navigation__aside--reduceWidth': reduceLeftPan
             //  }
            )
          }
       >
      <WalkThroughSideBar from={from} onClose={onClose} onClickSidebar={ ()=>this.onClickSidebar()}  offline={this.props.offline} onCollapsableSideBar={() => this.onCollapsableSideBar()} collapsableSideBar={collapsableSideBar}
      />
       </div>
     </OutsideClickHandler>
     <div
       className={
         classNames(
           'left-navigation__blinds',
           {
             'left-navigation__blinds--visible': sidebarIsVisible
           }
         )
       }
     />
     <div 
      className={from === "DeveloperWalkThrough" ?
                  classNames(
                    "with-navigation__body",
                      {
                        "with-navigation__body--collapseSideBar": collapsableSideBar
                      }
                    )
                    :
                    classNames(
                      "left-navigation__body",
                      {
                        "left-navigation__body--increaseBody":reduceLeftPan
                      }
                     )
                  }
     >
       <div className="left-navigation__hamburger-bar headerMobile">
         <div className="left-navigation__hamburger">
           <Button
             onClick={() => this.setState({ sidebarIsVisible: !sidebarIsVisible })}
             weight="semantic"
             icon={(
               <FontAwesomeIcon
                 weight="light"
                 glyph="bars"
               />
             )}
           />
         </div>
         <div className="left-navigation__logo">
           <img alt="juniper" src={Images.logo} 
             style={{height: theme === 'Quadra'|| theme === 'Panatch' ? '4rem': '1.7rem', marginTop:theme === 'Quadra'|| theme === 'Panatch' ? '5px': '10px'}}
           />
         </div>
       </div>
       <div className="left-navigation__yield">
         {body && (
           <div className="left-navigation__bottom">
             {body}
           </div>
         )}
         <div className="left-navigation__bottom">
           <div className="left-navigation__content">
             {/* {bottom} */}
           </div>
         </div>
       </div>
     </div>
   </Div100vh>
 </DocumentTitle></div>
    )
   }
 }


 const mapStateToProps = (state, ownProps) => {
   return {
    user: selectAuthenticatedUser(state),
    collapsableSideBar: selectCollapseSideBar(state),
   }
 }

 const mapDispatchToProps = dispatch => bindActionCreators({
  onSetSideBar: setSideBar,
 }, dispatch)
 
export default connect( mapStateToProps,mapDispatchToProps)(LeftNavigation)
